import { Seo } from "../components/Seo";
import { Eyebrow, Reveal } from "../components/ui-bits";
import { CTABand } from "../components/PageSections";
import { SITE } from "../data/site";

const POLICIES = [
  {
    title: "How to order",
    text: "We take orders by phone at (401) 822-4440 and in person at our shop, 1117 Main Street, Coventry, RI. We do not offer online ordering — every order is placed with a real florist who can answer questions, suggest what's freshest, and get the details right.",
  },
  {
    title: "Same-day delivery",
    text: "In most cases, orders placed before 3:00 p.m. can be delivered the same day throughout our delivery area: Coventry, RI and the Kent County area, including West Warwick, Warwick, East Greenwich, and West Greenwich. During major holidays, we recommend ordering several days ahead.",
  },
  {
    title: "Every delivery, hand-delivered and confirmed",
    text: "All deliveries are made with our own shop van and professional driver — never a relay service or shipping carrier. If the recipient isn't home, we'll contact you before leaving flowers unattended, and we confirm every completed delivery.",
  },
  {
    title: "Freshness & substitutions",
    text: "Our arrangements are designed from our own cooler and local growers. Because flowers are a perishable, seasonal product, an exact stem may occasionally be unavailable. When that happens, we substitute with flowers of equal or greater value, keeping the style, colors, and feel of the design you chose. You will never receive a lesser arrangement.",
  },
  {
    title: "100% satisfaction guarantee",
    text: "Every arrangement we sell carries our 100% satisfaction guarantee. If something isn't right, call us at (401) 822-4440 and we will make it right.",
  },
  {
    title: "Sympathy & funeral deliveries",
    text: "We coordinate directly with area funeral homes so tributes arrive on time and exactly as ordered. Please order as early as you can before the service; if time is short, call us and we will do everything possible.",
  },
  {
    title: "Hospital & facility deliveries",
    text: "We deliver regularly to Kent Hospital in Warwick and to nursing and rehabilitation facilities across the area, and we follow each facility's delivery procedures. Please note that some intensive care units do not accept flowers — if you're unsure, call us and we'll confirm before designing your arrangement.",
  },
  {
    title: "Holiday ordering",
    text: "For Valentine's Day, Mother's Day, Thanksgiving, and Christmas, we strongly recommend ordering several days ahead by phone — the holiday weeks are our busiest of the year, and early orders get the best of the cooler. Holiday pages stay on our site year-round so you can plan ahead anytime.",
  },
];

export default function Policies() {
  return (
    <>
      <Seo
        title="Store Policies | JIF – Jack Iannotti Flowers, Coventry RI"
        description="Ordering, same-day delivery, substitutions, and our 100% satisfaction guarantee — the plain-spoken policies of JIF Flowers, Coventry, RI."
      />
      <section className="mx-auto max-w-4xl px-5 pb-24 pt-40 sm:px-8">
        <Reveal>
          <Eyebrow>The Fine Print, Plainly</Eyebrow>
          <h1 className="mt-5 font-serif text-4xl font-medium leading-[1.08] tracking-tight text-plum sm:text-5xl lg:text-6xl">
            Our Policies
          </h1>
          <p className="mt-6 max-w-xl text-[17px] leading-relaxed text-charcoal/85 sm:text-[18px]">
            No jargon, no surprises. Here's exactly how we work at {SITE.name}.
          </p>
        </Reveal>
        <div className="mt-14 space-y-12">
          {POLICIES.map((p, i) => (
            <Reveal key={p.title} delay={Math.min(i * 0.04, 0.2)}>
              <div>
                <h2 className="font-serif text-2xl font-medium text-plum sm:text-[28px]">{p.title}</h2>
                <div className="gold-rule-left mt-3" aria-hidden="true" />
                <p className="mt-4 text-[16px] leading-relaxed text-charcoal/85">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <CTABand title="Questions about any of this? Call us" />
    </>
  );
}
